export enum QuickBooksMemberWarningTypeDTO {
  HAS_NO_QUICK_BOOKS_INTEGRATION = 'HAS_NO_QUICK_BOOKS_INTEGRATION',
  MEMBER_CURRENCY_MISMATCHES_QUICK_BOOKS = 'MEMBER_CURRENCY_MISMATCHES_QUICK_BOOKS',
}

export interface QuickBooksMemberWarningResponse {
  type: QuickBooksMemberWarningTypeDTO;
  args?: Record<string, unknown>;
}
